var map = {
	"./logo-i4m.svg": "Nw0D",
	"./logo-i4m_Dark.svg": "4ET9",
	"./logo-i4m_Dark_HC.svg": "gQm9",
	"./logo-i4m_HC.svg": "6NdG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DYSp";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo ^\.\/.*$
// module id = DYSp
// module chunks = 2